module.exports = __webpack_public_path__ + "static/media/photo-3-sm.780613d9.jpeg";